import { memo } from "react";

const HoneyDripDivider = memo(() => {
  return (
    <div className="relative h-12 -mt-1 overflow-hidden">
      <svg
        viewBox="0 0 1440 48"
        preserveAspectRatio="none"
        className="absolute inset-0 w-full h-full"
      >
        <path
          d="M0,0 L1440,0 L1440,8 C1380,8 1370,8 1360,12 C1350,18 1345,30 1335,36 C1325,42 1310,38 1305,30 C1300,22 1300,8 1280,8 L1100,8 C1080,8 1075,8 1065,14 C1055,22 1050,35 1040,40 C1030,45 1015,40 1010,32 C1005,24 1005,8 985,8 L780,8 C760,8 755,8 745,15 C735,24 730,38 720,42 C710,46 695,42 690,34 C685,26 685,8 665,8 L460,8 C440,8 435,8 425,13 C415,20 410,33 400,38 C390,43 375,39 370,31 C365,23 365,8 345,8 L160,8 C140,8 135,8 125,16 C115,26 110,40 100,44 C90,48 75,43 70,35 C65,27 65,8 45,8 L0,8 Z"
          fill="hsl(38, 92%, 50%)"
          opacity="0.2"
        />
        <path
          d="M0,0 L1440,0 L1440,4 C1340,4 1335,4 1330,8 C1325,14 1322,22 1315,26 C1308,30 1298,28 1295,22 C1292,16 1292,4 1275,4 L1060,4 C1043,4 1040,4 1035,9 C1030,16 1027,26 1020,30 C1013,34 1003,30 1000,24 C997,18 997,4 980,4 L740,4 C723,4 720,4 715,10 C710,18 707,28 700,32 C693,36 683,32 680,26 C677,20 677,4 660,4 L420,4 C403,4 400,4 395,10 C390,18 387,27 380,31 C373,35 363,31 360,25 C357,19 357,4 340,4 L100,4 C83,4 80,4 75,11 C70,20 67,30 60,34 C53,38 43,34 40,28 C37,22 37,4 20,4 L0,4 Z"
          fill="hsl(38, 92%, 50%)"
          opacity="0.35"
        />
      </svg>
    </div>
  );
});

HoneyDripDivider.displayName = "HoneyDripDivider";

export default HoneyDripDivider;
